import Vue from 'vue';

/**
 * Title Mixin
 *
 * This mixin is used to set the page title on a per view basis
 * The mixin looks for title property in the components data() method,
 * or a function named title in the computed properties option.
 *
 * Computed properties take precedence to data() properties where both are set.
 *
 * If a component has neither title function or title property, then the title remains unchanged.
 */

function getTitle(vm: any) {
  const { data, computed } = vm?.$options;
  let displayTitle;
   if (data) {
    const { title } = data.call();
    if (title) {
      displayTitle = title;
    }
  }
  if (computed) {
    const { title } = computed;
    if (title) {
      displayTitle = title;
    }
  }
  if (displayTitle) {
    return typeof displayTitle === 'function'
      ? displayTitle.call(vm)
      : displayTitle;
  }
}

export default Vue.extend({
  created() {
    const title = getTitle(this);
    if (title) {
      document.title = title;
    }
  },
});
